/**
 * Zee Pilates Studio üyelik sözleşmesi — stüdyonun basılı metni.
 *
 * Kaynak: `sözleşme/1.jpeg`, `2.jpeg`, `3.jpeg` (2026-09-30). Metin olduğu
 * gibi aktarıldı; yazım ve noktalama DÜZELTİLMEDİ — bu stüdyonun hukuki
 * metnidir, "düzeltilmiş" bir sürüm üyenin imzaladığı metin olmazdı.
 *
 * `version` imzayla birlikte saklanır: metin değiştiğinde sürüm de değişmeli,
 * yoksa eski imzalar yeni metni kabul etmiş görünür. Sürüm değişince üyelerden
 * yeniden imza istenir (bkz. `agreement.service`).
 *
 * Basılı formun başındaki kimlik numarası ve fiziksel rahatsızlık alanları
 * dijital imzada TOPLANMIYOR: stüdyonun istediği kayıt ad soyad + tarih;
 * kimlik numarası ve sağlık bilgisi KVKK kapsamında özel nitelikli veridir ve
 * gerekmedikçe tutulmaz.
 */

export const MEMBERSHIP_AGREEMENT_VERSION = '2026-09-30';

export interface AgreementSection {
  /** Bölüm başlığı — yoksa madde listesi başlıksız çizilir. */
  heading?: string;
  /** `ordered` ise maddeler `start`'tan numaralanır; değilse tireli liste. */
  ordered: boolean;
  start?: number;
  items: ReadonlyArray<{ text: string; subItems?: readonly string[] }>;
}

export const MEMBERSHIP_AGREEMENT = {
  title: '‘ZEE PILATES STUDIO’ ÜYELİK SÖZLEŞMESİ',
  sections: [
    {
      heading: 'GENEL KURALLAR',
      ordered: false,
      items: [
        { text: 'Kişisel eşyalarınızın güvenliğinden stüdyomuz sorumlu değildir.' },
        {
          text: 'Hijyen kurallarımız gereği, stüdyomuza girerken temiz ayakkabı ya da galoş kullanınız.Soyunma odalarındaki dolapları sadece stüdyoda iken kullanınız.Eşyalarınızı kitleyip bırakmayınız.',
        },
        { text: 'Kişisel bakımınıza önem veriniz.' },
        { text: 'Yanınızda kendi havlunuzu ya da peştemalinizi getiriniz.' },
        { text: 'Stüdyoda kullandığınız herşeyi bulduğunuz gibi bırakınız. Matları, ağırlıkları, vb.' },
        { text: 'Tuvalet ve duşları kullandıktan sonra bulmak istediğiniz gibi bırakınız.' },
        {
          text: 'Tuvaletlere, pamuk, ped, kağıt vb. atmayınız. Sizler için bulundurduğumuz çöplere atınız.',
        },
        {
          text: 'Alınan paket geçerlilik süresi (özel gruplar hariç) 45 gündür. Bu süre dolduktan sonra ders hakkı kalmayacaktır.',
        },
        { text: 'Üye, kendisine ait üyelik hakkını devredemez.' },
        { text: 'Herhangi bir nedenle her pakette belirtilen ders erteleme adeti aşılmayacaktır.' },
        {
          text: 'Üye, derse gelemeyeceğini en geç 1 gün önceden haber vermekle yükümlüdür. Aksi takdirde ders yapılmış sayılacaktır.',
        },
        { text: 'Mat Pilates Grup derslerinde iptal ya da telafi hakkı bulunmamaktadır.' },
        {
          text: 'Reformer Pilates grup derslerinde, üye en geç bir gün önce haber verdiği takdirde bir ders telafi hakkı bulunmaktadır. Bu hakkını paketinin bitiminden hemen sonra kullanabilir.',
        },
      ],
    },
    {
      ordered: true,
      start: 1,
      items: [
        {
          text: 'Zee Pilates Stüdyo, tesis içi tadilata gerek gördüğünde, tadilat için kapalı olunacak sürenin duyurusunu üyelere önceden duyurur.',
        },
        { text: 'Üyeler, tesisten yararlanmak için, kurallara uygun kıyafetleri kullanmak zorundadır.' },
        {
          text: 'Tesise evcil hayvan, dışarıdan yiyecek-içecek, spor ya da oyun amaçlı malzeme getirilemez.',
        },
        { text: 'Tesis salonlarında izinsiz çekim yapılamaz.' },
        {
          text: 'Tesise öldürücü ve yaralayıcı araçlarla (çakı, bıçak, ruhsatlı dahi olsa silah vb.) girilemez.',
        },
        {
          text: 'Sağlık açısından tesis kullanımı öncesinde alkol ve diğer yiyecekler içecekler alınmamalıdır.',
        },
        {
          text: 'Tesisin genel hijyen ve temizliğini korumak için tesisin sunduğu hijyenik çözümlere (galoş, bone vs.) uyulması zorunludur.',
        },
        {
          text: 'Üyelerin; yakını, seyirci, hizmetçi, yardımcı vs. adı altında yanlarında getirecekleri ikinci şahıslar spor alanlarına izinsiz alınmaz.',
        },
        {
          text: 'Zee Pilates Stüdyo günün şartlarına göre gerekli gördüğünde, kullanıcı kurallarını değiştirme, kaldırma ya da yeni kurallar ekleme hakkına sahiptir.',
        },
        {
          text: 'Üye, tesisin yetkililerinden izin almadan spor alet ve ekipmanlarının yerini değiştiremez, izin alarak yerini değiştirdiği spor alet ve ekipmanlarını seans sonunda yerine koymakla yükümlüdür.',
        },
        {
          text: 'Üye, görevli kişilerin uyarılarına uymak zorundadır. Bu uyarılara ve kurallara uymayanların üyelikleri tek taraflı olarak fesh edilecektir.',
        },
        {
          text: 'Üye, ders sırasında hocaya müdahale edemez ve hocanın verdiği komut dışında hareket edemez. Aksi takdirde Zee Pilates Stüdyo herhangi bir sorumluluk kabul etmez.',
        },
        {
          text: 'Üye, Zee Pilates Stüdyo bünyesinde yer alan hizmetlerden, Zee Pilates Stüdyo tarafından belirlenen tüm kurallara ve şartlara uygun davranmak koşulu ile Zee Pilates Stüdyo tarafından belirlenecek saatler içinde faydalanabilir.',
        },
        {
          text: 'Üyelik süresince meydana gelebilecek herhangi bir fiziksel ruhsal veya sair her türlü zarar ile kayıp, yaralanma ve benzeri sağlık problemlerinden ve bunların sonuçlarından ötürü Zee Pilates Stüdyo’ nun cezai ve hukuki sorumluluğu bulunmamaktadır. Üye bu hususta Zee Pilates Stüdyo veya çalışanlarına her ne şart altında olursa olsun cezai ve hukuki işlem başlatmayacağını peşinen kabul ve taahhüt etmektedir.',
        },
        { text: 'Üyelik sözleşmesi taraflardan birisi feshetmediği sürece yürürlükte kalır.' },
        {
          text: 'Üyeliklerde iptal işleminde üyeye herhangi bir bedel iadesi ödemesi yapılmayacaktır.',
        },
        {
          text: 'Üyeye herhangi bir iade yapılacak ise bu iade ancak üyenin kendisine ait kart veya hesabına yapılacaktır. Bunun dışında başka bir tüzel veya gerçek kişiye ait kart veya hesaba iade yapılmayacaktır. Üye, bu yönde bir talebinin kabul edilmeyeceğini peşinen kabul veya taahhüt eder.',
        },
        {
          text: 'Zee Pilates Stüdyo aşağıda ki durumlarda tek taraflı olarak fesih ve üyeliğin iptali hakkına sahiptir. Bu durumda üye herhangi bir tazminat ve iade talep edemez.',
          subItems: [
            'Üyenin hukuk, ahlak ve adap kurallarına aykırı bir biçimde davranması,',
            'Tesis içinde üyelere rahatsızlık vermesi,',
            'Hukuki ve cezai anlamda suç teşkil edecek eylemlerde bulunması,',
            'Zee Pilates Stüdyo ‘ a gerçeğe aykırı bilgi verdiğinin tespit edilmesi,',
            'Üyelik bedelinin kısmen ya da tamamen ödenmemesi,',
            'Zee Pilates Stüdyo aleyhine asılsız ve ticari itibarı zedeleyen davranış ve beyanlarda bulunması,',
            'Tesis içinde ticari amaçlı faaliyetlerde bulunması,',
            'Başka bir üyeye özel ders vermesi,',
            'Zee Pilates Stüdyo hakkında edindiği ticari ve diğer tesis bilgilerini benzeri kurum veya kuruluşlara vermesi,',
            'Zee Pilates Stüdyo ’nun üyeliğin devamını imkansız gördüğü diğer her türlü hal ve durumlarda',
          ],
        },
        {
          text: 'Sayın Zee Pilates Stüdyo üyesi bu anlaşma ile kendisinin yaptırdığı doktor muayenesi sonucu sağlık durumun iyi olduğunu, aktif egzersizlere katılmasına engel bir özrünün, sakatlığının, rahatsızlığının veya yasaklılığının bulunmadığını, bu tip egzersizlere katılmasının sağlığına ve fiziksel durumuna bir zarar vermeyeceğini beyan ederek yapacağı her türlü egzersizlerin sonucunda doğabilecek yaralanma ve zararların sonucunda sorumluluğu tarafınıza aittir. Zee Pilates Stüdyo bu beyanın yanlış, eksik veya yanıltıcı olarak verilmiş olmasından doğabilecek hasarlardan ve sakatlanmalardan sorumlu tutulamaz. Kullanıcı bu sorumluluğa katlanmayı taahhüt eder.',
        },
        {
          text: 'Üye bu sözleşmeyi onaylaması sırasında Zee Pilates Stüdyo tarafından kendisinden talep edilen her türlü bilgiyi noksansız ve doğru olarak verdiğini kabul etmektedir.',
        },
        { text: 'Her üyelik için ayrı kurallar oluşabileceği için ek sözleşme yapılacaktır.' },
        { text: 'Üye, imza anında tüm kuralları okumuş ve kabul etmiş olmaktadır.' },
        {
          text: 'Üye, hak ve yükümlülüklerinin üyelik sözleşmesinin imzası sırasında kendisine anlatıldığını ve hak ve sorumluluklarının bilincinde olduğunu ve kabul ettiğini taahhüt eder.',
        },
      ],
    },
  ] satisfies AgreementSection[],
  /** İmza bloğu — basılı formdaki "ÜYE (18 yaş altı için Veli)". */
  signatureLabel: 'ÜYE (18 yaş altı için Veli)',
} as const;
